import * as angular from 'angular';
import { ComponentDefinition } from '../../../models';
import { IConfigurationObject, IConfigurationService, IContextualDocConfiguration, IContextualDocEntry, ICustomHelp } from '../../../services';

class HelpButtonController implements angular.IComponentController {
    
    menu: IContextualDocEntry[] = [];
    hasEdit: boolean;
    hasContextualMenu: boolean = false;
    help: ICustomHelp;
    state: string;
    
    private _config: IConfigurationObject;
    private _contextual: IContextualDocConfiguration;
    
    static $inject = ['$q', 'configurationService'];
    constructor(
        private _$q: angular.IQService,
        private _configurationService: IConfigurationService
    ) {
        this.help = {
            icon: 'fa-question-circle',
            tooltip: 'Help',
            url: 'docs/help/'
        };
    }

    $onInit() {
        this._$q.all([
            this._configurationService.getConfiguration(),
            this._configurationService.getContextualDocConfiguration()
        ])
        .then(all => {
            this._config = all[0];
            this._contextual = all[1];
        })
        .finally(() => {
            this.refresh();
        });
    }

    $onChanges() {
        this.refresh();
    }

    private refresh() {
        const menu: IContextualDocEntry[] = [];
        let hasMenu = false;

        // legacy custom help replacement
        if (this._config?.customHelp) {
            this.help = this._config.customHelp;
        }

        // if we have all info in our hand
        if (this._config && this._contextual && this.state) {
            const entries = this._contextual[this.state]?.links;
            const hasEntries = entries?.length > 0;
            const hasCustom = !!this._config.customHelp;

            hasMenu = hasEntries || hasCustom;
            // if we have custom help add it has first entry
            if (hasCustom) {
                menu.push({
                    description: this._config.customHelp.tooltip,
                    icon: this._config.customHelp.icon,
                    tooltip: this._config.customHelp.tooltip,
                    isEditMode: false,
                    url: this._config.customHelp.url
                });
            }
            // if we have entries take all if we can edit, else only the one not related to edit
            if (hasEntries) {
                menu.push(...entries.filter(e => this.hasEdit || !e.isEditMode));
            }
        }

        this.hasContextualMenu = hasMenu;
        this.menu = menu;
    }
}

export const wtHelpButton: ComponentDefinition = {
    componentId: 'wtHelpButton',
    controller: HelpButtonController,
    template: require('./helpButton.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        hasEdit: '<',
        state: '<'
    }
};